import { Select } from "antd"
import { useEffect, useState } from 'react';
import { getAllCIIU, getCIIU } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface Props  {
    onChange: (value : string) => void,
    disabled? : boolean,
    placeholder : string,
    size? : SizeType,
    defaultValue? : string,
    mode? : any;
    style? : any
    onClear : () => void,
}

const SelectCommercialActivityType = (props: Props) => {
    const [ciius, setCiius] = useState([]);
    useEffect(() => {
        const getciiu = async () => {
            const items = await getAllCIIU();
            setCiius(items.map((c: any) => {
                return {
                    value: c.id,
                    label: c.description
                }
            }));
        }

        getciiu();
    }, []);
    
    return (
        <div style={{width : '100%'}}>
            <Select
                {...props}
                size={props.size}
                labelInValue
                allowClear
                onClear={() => {
                    if(props.onClear){
                        props?.onClear();
                    }
                }}
                disabled={props.disabled}
                style={props.style}
                onChange={(value:any) => {
                    props.onChange(value);
                }}
                options={ciius}
            />        
        </div>
    );
}

export default SelectCommercialActivityType